import React, { forwardRef } from 'react'

import MentionTextarea, {
    MentionTextareaRef,
    MentionUserOption,
} from '~components/shared/inputs/mention-textarea'
import { getUserFullName } from '~utils/helpers'
import { useTeamChatConversation } from '../provider'

interface Props {
    value: string
    onChange: (newValue: string) => void
}

/**
 * Team chat composer textarea. Supports `@`-mentioning teammates that are
 * participants of the current internal chat. The mention markup is
 * persisted directly to the message body and rendered as chips by
 * `MentionText` on the read side.
 */
const TeamChatInputTextarea = forwardRef<MentionTextareaRef, Props>(
    ({ value, onChange }, ref) => {
        const { internalChat, currentInternalChatUser } =
            useTeamChatConversation()

        const mentionUsers: MentionUserOption[] =
            (internalChat?.internal_chat_users || [])
                .filter(
                    icu =>
                        // Don't suggest the sender themselves; they can't
                        // meaningfully mention themselves.
                        icu.user.id !== currentInternalChatUser?.user.id,
                )
                .map(icu => ({
                    id: icu.user.id,
                    display: getUserFullName(icu.user),
                    avatarUrl: icu.user.avatar_url,
                }))

        return (
            <MentionTextarea
                ref={ref}
                value={value}
                onChange={onChange}
                placeholder="Type message here..."
                mentionUsers={mentionUsers}
            />
        )
    },
)

TeamChatInputTextarea.displayName = 'TeamChatInputTextarea'

export default TeamChatInputTextarea
